import { render } from "./Measurements.vue?vue&type=template&id=319be54a&scoped=true"
import script from "./Measurements.vue?vue&type=script&lang=ts"
export * from "./Measurements.vue?vue&type=script&lang=ts"

import "./Measurements.vue?vue&type=style&index=0&id=319be54a&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-319be54a"

export default script